'use client';

import { useMemo } from 'react';
import { formatAmountV2 } from 'utils/formatAmount';
import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import { StakingVaultResponse, UserStakingResponse } from 'models/stake';
import stakingApi from 'api/stakingApi';
import { showSuccessModal } from 'components/Modals/CommonModals';
import { selectStakeList, setUpdateStakeListResult } from 'redux/userSlice';
import teraber_coin_logo from 'assets/images/terabet_coin_logo.png';
interface ClaimVaultProps {
  vault: StakingVaultResponse;
}

const ClaimVaultOffChain = ({ vault }: ClaimVaultProps) => {
  const t = useAppTranslation();
  const stakeList = useAppSelector(selectStakeList);
  const dispatch = useAppDispatch();

  const canClaimItem = useMemo(() => {
    return stakeList && stakeList?.filter((stake) => stake?.stakingVaultDto.id === vault.id);
  }, [stakeList.length]);
  //

  const handleClaim = async () => {
    const { ok } = await stakingApi.claim(vault.id);
    if (ok) {
      showSuccessModal({
        content: t('staking.success.claim-title'),
      });
      dispatch(setUpdateStakeListResult());
    }
  };

  const totalStaking = useMemo(() => {
    const countStaking =
      canClaimItem.length > 0
        ? canClaimItem
            ?.filter((stake) => stake?.stakingVaultDto.id === vault.id)
            .reduce((total, postion) => {
              return total + Number(postion.stakeAmount);
            }, 0)
        : 0;
    const countReward = canClaimItem.reduce((total, item) => {
      return new Date(item.claimDate) <= new Date() ? total + Number(item.rewardAmount) : total;
    }, 0);
    return {
      staking: countStaking,
      reward: countReward,
    };
  }, [stakeList.length, canClaimItem]);

  return (
    <div className="claim-item">
      <div className="claim-item-info">
        <div className="claim-amount">
          <div className="claim-amount__info">
            <p className="amount-title">{t('staking.form.staking')}:</p>
            <p className="amount-number primary-text-color">
              {formatAmountV2(totalStaking.staking, 8)}
              <img className="" src={teraber_coin_logo} alt="terabet_logo" width={20} />
            </p>
          </div>
          <div className="claim-amount__info">
            <p className="amount-title">{t('staking.form.reward')}:</p>
            <p className="amount-number primary-text-color">
              {formatAmountV2(totalStaking.reward, 8)}
              <img className="" src={teraber_coin_logo} alt="terabet_logo" width={20} />
            </p>
          </div>
        </div>
      </div>
      <div className="claim-btn-wrap">
        <span className="fz-sm">{t(vault.label)}</span>
        <button className="claim-button" onClick={handleClaim} disabled={totalStaking.reward <= 0}>
          {t('staking.form.claim')}
        </button>
      </div>
    </div>
  );
};

export default ClaimVaultOffChain;
